import {URL} from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";
import Urls from "../../url/Urls";

export const getRequestNotary = async (page:number, size: string, filter:string) => {
  let responseData = {};  
  const params = new URLSearchParams([    
    ["description", filter],
    ["type", "J"]
  ]);
  let keysParams:any = [];
  params.forEach((value, key) => {
    if (value === '' || value === null) {
      keysParams.push(key);
    }
  });
  keysParams.forEach((key:any) => {
    params.delete(key);
  });  
  await privateFetch
    .get(
      URL.REQUEST_NOTARY(page, 
        //@ts-ignore
        size !== "" ? size :  
        Urls.registration_x_page,
        filter)
      
    )
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {      
      throw new Error(error.message);
    });
  return responseData;
};

export const addUpdRequestNotary = async (data:any, option:string) => {
  let responseData = {}; 
  await privateFetch
    .put(URL.REQUEST_NOTARY_CUD(option), data, {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(error.message);
    });
  return responseData;
};


export const deleteRequestNotary = async (id:any) => {
  let responseData = {};
  await privateFetch
    .delete(URL.REQUEST_NOTARY_CUD(id), {})
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {      
      throw new Error(error.message)
    });
  return responseData;
};
